import { FC } from 'react';
import { DownloadArrowIcon, SaveIcon } from '../../../lib/icons';
import { IconProps } from '../../../lib/icons/templates/icon';
import { TaskBaseProps, TaskType } from './types';

const taskIcon: Record<TaskType, FC<IconProps>> = {
  import: SaveIcon,
  export: DownloadArrowIcon
};

export const TaskIcon: FC<TaskBaseProps> = ({ type: context }) => {
  const Icon = taskIcon[context];
  return <Icon />;
};
